/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CompanyStatus {
    PENDING = 'pending',
    ACTIVE = 'active',
    DEPROVISIONING = 'deprovisioning',
}
